<template>
  <span :title="$gettext('GPS Track')">
    <icon-geometry-detail />
  </span>
</template>
